//since this is small site this is fine and i dont feel like writing css

export const AuthBtnsStyle = {
    login: {
        backgroundColor: 'blue',
        color: 'white',
        textAlign: 'center',
        fontSize: 20,
        borderRadius: 25,
        border: 'none',
    },
    sign_up: {
        backgroundColor: 'red',
        color: 'white',
        textAlign: 'center',
        fontSize: 20,
        borderRadius: 25,
        border: 'none',
    }
}

export const HomeBtnStyle = {
    backgroundColor: 'orange',
    color: 'white',
    textAlign: 'center',
    fontSize: 20,
    borderRadius: 25,
    border: 'none',
}

export const homePgBtnStyles = {
    people_to_call: {
        ...AuthBtnsStyle.login
    },
    resources: {
        backgroundColor: 'green',
        color: 'white',
        textAlign: 'center',
        fontSize: 20,
        borderRadius: 25,
        border: 'none',
    },
    request: {
        ...AuthBtnsStyle.sign_up
    },
}

export const SubmitBtnStyle = { ...AuthBtnsStyle.login }

export const accordionBtnStyle = { ...AuthBtnsStyle.login }

export const articleBtnStyle = { ...homePgBtnStyles.resources }

export const requestBtnStyle = { ...AuthBtnsStyle.sign_up }

export const BtnClsNames = "w-100 py-3 py-md-2"